import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { IContaDre } from '../models/conta_dre.model';

@Injectable()
export class ContaDreService extends EntityService<IContaDre> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'conta_dre',
      urlBackend: configService.backendURL
    });
  }
}
